import * as Sentry from '@sentry/react'

export const trackClientError = (error: Error, context?: Record<string, any>) => {
  // Track in Sentry
  Sentry.withScope((scope) => {
    if (context) {
      Object.entries(context).forEach(([key, value]) => {
        scope.setExtra(key, value)
      })
    }
    Sentry.captureException(error)
  })

  // PostHog removed - only Sentry tracking remains
}

export const trackApiError = (error: any) => {
  const context = {
    url: error.config?.url,
    method: error.config?.method,
    status: error.response?.status,
    statusText: error.response?.statusText,
    responseData: error.response?.data
  }

  trackClientError(error, context)
} 